import { useQuery } from "@tanstack/react-query";
import { useI18n } from './use-i18n';

export interface AudioguidesAvailability {
  available: boolean;
  count: number;
}

/**
 * Disponibilità e numero di audioguide per la lingua corrente. Alimenta la voce
 * di menu: le audioguide sono schede con audio, quindi il conteggio dipende
 * dalla colonna audio della lingua, non dal totale delle schede.
 */
export function useAudioguidesAvailability() {
  const { language } = useI18n();

  return useQuery<AudioguidesAvailability>({
    queryKey: ['/api/audioguides/available', language],
    queryFn: async () => {
      const res = await fetch(`/api/audioguides/available?lang=${language}`, {
        credentials: 'include'
      });
      if (!res.ok) return { available: false, count: 0 };
      const data = await res.json();
      return { available: Boolean(data.available), count: Number(data.count) || 0 };
    },
    staleTime: 60 * 60 * 1000, // 1h — cambia raramente
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
